import React, {useState} from "react";
import "./TextBox.scss";
import TextField from "@mui/material/TextField";
import {isPositiveInteger} from "../../Utilities/validation";

const TextBox = (props) => {
  const className = props.className
      ? `${props.className} instream-textbox`
      : "instream-textbox";

  let inputProps = {};
  if (isPositiveInteger(props.maxLength)) {
    inputProps = {
      ...inputProps,
      maxLength: props.maxLength ? props.maxLength : 30
    }
  }
  if (isPositiveInteger(props.minLength)) {
    inputProps = {
      ...inputProps,
      minLength: props.minLength ? props.minLength : 0
    }
  }
  if (props.inputComponent) {
    inputProps = {
      ...inputProps,
      inputComponent: props.inputComponent
    }
  }

  const [state, setState] = useState({
    hasError: false,
    helperText: null
  });

  const handleChange = (e) => {
    const helperText = props.validate ? props.validate(e.target.value) : null;
    if (helperText != null) {
      setState({
        hasError: true,
        helperText: helperText
      });
    } else {
      setState({
        hasError: false,
        helperText: null
      });
    }

    props.onChange(e);
  };

  return (
      <TextField
        {...props}
        error={state.hasError || props.hasError}
        variant="outlined"
        color="primary"
        label={props.label}
        size={props.size ? props.size : "small"}
        value={props.value}
        disabled={props.disabled}
        onChange={handleChange}
        helperText={state.helperText}
        className={className}
        inputProps={inputProps}
      />
  );
};

export default TextBox;
